/* FERAL — JS mínimo, vanilla, sin librerías.
   Solo lo que no puede resolverse en CSS o Liquid. */
(function () {
  'use strict';

  var dinero = function (centavos) {
    var n = Math.round(centavos / 100).toString();
    var partes = [];
    while (n.length > 3) {
      partes.unshift(n.slice(-3));
      n = n.slice(0, -3);
    }
    partes.unshift(n);
    return '$ ' + partes.join('.');
  };

  /* ---------- Anuncio descartable ---------- */
  var anuncio = document.querySelector('[data-anuncio]');
  if (anuncio) {
    var claveAnuncio = 'feral:anuncio:' + anuncio.dataset.anuncio;
    if (sessionStorage.getItem(claveAnuncio) === 'cerrado') {
      anuncio.hidden = true;
    }
    var cerrarAnuncio = anuncio.querySelector('[data-anuncio-cerrar]');
    if (cerrarAnuncio) {
      cerrarAnuncio.addEventListener('click', function () {
        anuncio.hidden = true;
        try { sessionStorage.setItem(claveAnuncio, 'cerrado'); } catch (e) {}
      });
    }
  }

  /* ---------- Navegación móvil ---------- */
  var panel = document.querySelector('[data-panel-nav]');
  var abrirNav = document.querySelector('[data-abrir-nav]');
  if (panel && abrirNav) {
    var cerrarNav = panel.querySelector('[data-cerrar-nav]');
    var mostrarNav = function (estado) {
      if (estado) { panel.setAttribute('open', ''); } else { panel.removeAttribute('open'); }
      abrirNav.setAttribute('aria-expanded', String(estado));
      document.body.toggleAttribute('data-bolsa-abierta', estado);
      if (estado) {
        var primero = panel.querySelector('a, button');
        if (primero) primero.focus();
      } else {
        abrirNav.focus();
      }
    };
    abrirNav.addEventListener('click', function () { mostrarNav(true); });
    if (cerrarNav) cerrarNav.addEventListener('click', function () { mostrarNav(false); });
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') mostrarNav(false);
    });
  }

  /* ---------- Carrito lateral ---------- */
  var bolsa = document.querySelector('[data-bolsa]');
  var velo = document.querySelector('[data-velo]');
  var ultimoFoco = null;

  function refrescarBolsa() {
    return fetch(window.Shopify.routes.root + '?section_id=feral-bolsa', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevo = doc.querySelector('[data-bolsa-interior]');
        var actual = bolsa && bolsa.querySelector('[data-bolsa-interior]');
        if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
        // El resumen fijo vive en la misma sección: se refresca con ella.
        var slotNuevo = doc.querySelector('[data-resumen-slot]');
        var slotActual = document.querySelector('[data-resumen-slot]');
        if (slotNuevo && slotActual) slotActual.innerHTML = slotNuevo.innerHTML;

        var fuente = doc.querySelector('[data-cuenta-total]');
        if (fuente) {
          var n = parseInt(fuente.textContent, 10) || 0;
          var todos = document.querySelectorAll('[data-cuenta-bolsa]');
          for (var i = 0; i < todos.length; i++) todos[i].textContent = n > 0 ? String(n) : '';
        }
      });
  }

  function mostrarBolsa(estado) {
    if (!bolsa) return;
    if (estado) {
      ultimoFoco = document.activeElement;
      bolsa.setAttribute('data-abierto', '');
      if (velo) velo.setAttribute('data-abierto', '');
      document.body.setAttribute('data-bolsa-abierta', '');
      var cerrar = bolsa.querySelector('[data-bolsa-cerrar]');
      if (cerrar) cerrar.focus();
    } else {
      bolsa.removeAttribute('data-abierto');
      if (velo) velo.removeAttribute('data-abierto');
      document.body.removeAttribute('data-bolsa-abierta');
      if (ultimoFoco) ultimoFoco.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var abrir = e.target.closest('[data-abrir-bolsa]');
    if (abrir && bolsa) { e.preventDefault(); mostrarBolsa(true); return; }
    if (e.target.closest('[data-bolsa-cerrar]') || e.target.closest('[data-velo]')) {
      mostrarBolsa(false);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && bolsa && bolsa.hasAttribute('data-abierto')) mostrarBolsa(false);
  });

  /* ---------- Añadir conjunto: las 2-3 piezas en un clic ---------- */
  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-conjunto-anadir]');
    if (!boton) return;
    e.preventDefault();
    var ids = (boton.dataset.conjuntoAnadir || '').split(',').filter(Boolean);
    if (!ids.length) return;
    var articulos = ids.map(function (id) { return { id: Number(id), quantity: 1 }; });
    var etiqueta = boton.textContent;
    boton.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: articulos })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('carrito');
        return r.json();
      })
      .then(function () {
        boton.setAttribute('data-hecho', '');
        return refrescarBolsa();
      })
      .then(function () {
        mostrarBolsa(true);
        setTimeout(function () { boton.removeAttribute('data-hecho'); }, 1200);
      })
      .catch(function () {
        boton.textContent = 'No pudimos añadirlo. Intenta de nuevo.';
        setTimeout(function () { boton.textContent = etiqueta; }, 2600);
      })
      .finally(function () { boton.disabled = false; });
  });

  /* ---------- Cantidades y retiro dentro del carrito ---------- */
  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-linea-cambiar]');
    if (!boton) return;
    e.preventDefault();
    var linea = Number(boton.dataset.lineaCambiar);
    var cantidad = Number(boton.dataset.lineaCantidad);
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: linea, quantity: cantidad })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refrescarBolsa(); });
  });

  /* ---------- Paneles del encabezado: teclado y toque ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var abierto = document.querySelector('.panel[data-abierto]');
    if (abierto) {
      abierto.removeAttribute('data-abierto');
      var cabeza = abierto.parentElement.querySelector('.nav-item__cabeza');
      if (cabeza) { cabeza.setAttribute('aria-expanded', 'false'); cabeza.focus(); }
    }
  });

  /* ---------- Ventana de correo ---------- */
  (function () {
    var ventana = document.querySelector('[data-ventana]');
    if (!ventana) return;

    var clave = ventana.dataset.clave || 'feral:correo';
    var retardo = Math.max(20, Number(ventana.dataset.retardo) || 25) * 1000;
    var yaFue = false;
    var ultimoFocoV = null;

    function guardar() {
      try { localStorage.setItem(clave, '1'); } catch (e) {}
    }
    function visto() {
      try { return localStorage.getItem(clave) === '1'; } catch (e) { return false; }
    }
    function abrir() {
      if (yaFue || ventana.hidden === false) return;
      // Nunca encima del menú ni del carrito: se reintenta más tarde.
      if (document.body.hasAttribute('data-bolsa-abierta')) {
        setTimeout(abrir, 8000);
        return;
      }
      yaFue = true;
      ultimoFocoV = document.activeElement;
      ventana.hidden = false;
      document.body.setAttribute('data-bolsa-abierta', '');
      var f = ventana.querySelector('input, button');
      if (f) f.focus();
    }
    /* ?ventana=1 la fuerza a abrir saltándose el «ya la vio» y el disparo por
       scroll. Sirve para revisarla o enseñarla sin borrar el almacenamiento,
       y en ese modo tampoco la marca como vista. */
    /* ?ventana=1  → se salta el «ya la vio» pero MANTIENE el disparo por
                      scroll: sirve para probar el comportamiento real.
       ?ventana=ya → abre al momento, solo para mirar el diseño.
       En ambos casos no la marca como vista al cerrarla. */
    var _p = (window.location.search.match(/[?&]ventana=([^&]*)/) || [])[1];
    var revisar = _p === '1';
    var yaMismo = _p === 'ya';
    var forzar = revisar || yaMismo;

    function cerrar() {
      ventana.hidden = true;
      document.body.removeAttribute('data-bolsa-abierta');
      if (!forzar) guardar();
      if (ultimoFocoV && ultimoFocoV.focus) ultimoFocoV.focus();
    }

    // Si el envío fue correcto, Liquid ya pintó el estado de éxito: mostrarlo.
    if (ventana.querySelector('.ventana__codigo')) {
      guardar();
      ventana.hidden = false;
      document.body.setAttribute('data-bolsa-abierta', '');
      yaFue = true;
    } else if (yaMismo) {
      setTimeout(abrir, 300);
    } else if (revisar || !visto()) {
      /* Disparo principal: haber terminado de pasar una sección concreta
         (por defecto «Empieza por aquí»). Quien llega ahí ya vio catálogo.
         Se usa scroll + rAF y no IntersectionObserver, que en este proyecto
         resultó no dispararse en el navegador de pruebas.
         Suelo de 4 s para que un scroll rapidísimo no lo vuelva inmediato. */
      var sel = ventana.dataset.disparo;
      var ancla = sel ? document.querySelector(sel) : null;
      var desde = Date.now();

      if (ancla) {
        /* Una medición por evento de scroll y listo. Sin requestAnimationFrame:
           no se ejecuta en pestañas de fondo, así que el disparo se quedaba
           colgado si el visitante cambiaba de pestaña mientras leía. */
        /* La foto es lazy dentro de un contenedor oculto, así que no empieza a
           bajar hasta que el popup abre y se ve un hueco. Se precarga cuando
           el visitante está a punto de disparar, no antes: quien nunca llega
           ahí no paga esos 127 KB. */
        var foto = ventana.querySelector('.ventana__medio img');
        var precargada = false;
        var mirar = function () {
          if (yaFue) return;
          var abajo = ancla.getBoundingClientRect().bottom;
          if (foto && !precargada && abajo < innerHeight) {
            precargada = true;
            var previa = new Image();
            previa.src = foto.currentSrc || foto.src;
          }
          if (abajo > 0) return;                                  // aún no la pasa
          if (Date.now() - desde < 4000) return;                  // ni instantáneo
          window.removeEventListener('scroll', mirar);
          abrir();
        };
        window.addEventListener('scroll', mirar, { passive: true });
      } else {
        setTimeout(abrir, retardo);
      }

      // Intención de salida, solo con puntero fino (escritorio).
      if (window.matchMedia('(pointer:fine)').matches) {
        document.addEventListener('mouseout', function (e) {
          if (e.relatedTarget || e.clientY > 0) return;
          if (Date.now() - desde < 4000) return;   // el cursor sale hacia la
          abrir();                                 // barra al pegar la URL
        });
      }
    }

    ventana.addEventListener('click', function (e) {
      if (e.target.closest('[data-ventana-cerrar]')) cerrar();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !ventana.hidden) cerrar();
    });
  })();

  /* ---------- Galería de la ficha ---------- */
  (function () {
    var galeria = document.querySelector('[data-galeria]');
    if (!galeria) return;
    var pista = galeria.querySelector('[data-galeria-pista]');
    var minis = [].slice.call(galeria.querySelectorAll('[data-galeria-ir]'));
    var zoom = galeria.querySelector('[data-zoom-abrir]');
    if (!pista || !minis.length) return;

    function marcar(i) {
      for (var n = 0; n < minis.length; n++) {
        var act = n === i;
        minis[n].toggleAttribute('data-activo', act);
        if (act) { minis[n].setAttribute('aria-current', 'true'); }
        else { minis[n].removeAttribute('aria-current'); }
      }
      // La lupa abre siempre la foto que se está viendo, no la primera.
      if (zoom && minis[i]) {
        zoom.setAttribute('data-zoom-src', minis[i].dataset.zoomSrc);
        zoom.setAttribute('data-zoom-alt', minis[i].dataset.zoomAlt || '');
      }
    }

    minis.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = Number(b.dataset.galeriaIr) || 0;
        pista.scrollTo({ left: pista.clientWidth * i });
        marcar(i);
      });
    });

    /* El carril manda: si deslizas, la miniatura se pone al día. Se mide en
       el propio scroll y no con IntersectionObserver, que en este proyecto
       resultó no dispararse. */
    var ultimo = 0;
    pista.addEventListener('scroll', function () {
      var i = Math.round(pista.scrollLeft / pista.clientWidth);
      if (i !== ultimo && minis[i]) { ultimo = i; marcar(i); }
    }, { passive: true });
  })();

  /* ---------- Ficha: añadir al carrito sin recargar ---------- */
  function anadirVariante(id, boton) {
    var etiqueta = boton ? boton.textContent : '';
    if (boton) boton.disabled = true;
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('carrito'); return r.json(); })
      .then(function () {
        if (boton) boton.setAttribute('data-hecho', '');
        return refrescarBolsa();
      })
      .then(function () {
        mostrarBolsa(true);
        setTimeout(function () { if (boton) boton.removeAttribute('data-hecho'); }, 1200);
      })
      .catch(function () {
        if (boton) {
          boton.textContent = 'No pudimos añadirlo. Intenta de nuevo.';
          setTimeout(function () { boton.textContent = etiqueta; }, 2600);
        }
      })
      .finally(function () { if (boton) boton.disabled = false; });
  }

  var formaProducto = document.querySelector('[data-forma-producto]');
  if (formaProducto) {
    formaProducto.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = formaProducto.querySelector('[name="id"]').value;
      anadirVariante(id, formaProducto.querySelector('[data-anadir]'));
    });
  }

  var botonBarra = document.querySelector('[data-anadir-barra]');
  if (botonBarra) {
    botonBarra.addEventListener('click', function () {
      anadirVariante(botonBarra.dataset.variante, botonBarra);
    });
  }

  /* ---------- Ficha: barra fija al pasar el botón ---------- */
  var barra = document.querySelector('[data-barra]');
  var anclaCta = document.querySelector('[data-forma-producto]');
  if (barra && anclaCta) {
    var pendiente = false;
    var revisarBarra = function () {
      pendiente = false;
      barra.hidden = anclaCta.getBoundingClientRect().bottom > 0;
    };
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(revisarBarra); }
    }, { passive: true });
    window.addEventListener('resize', revisarBarra, { passive: true });
    revisarBarra();
  }

  /* ---------- Ficha: ver de cerca ---------- */
  var lupa = document.querySelector('[data-zoom]');
  if (lupa) {
    var lupaImg = lupa.querySelector('[data-zoom-img]');
    var focoLupa = null;
    document.addEventListener('click', function (e) {
      var abrir = e.target.closest('[data-zoom-abrir]');
      if (abrir) {
        focoLupa = abrir;
        lupaImg.src = abrir.dataset.zoomSrc;
        lupaImg.alt = abrir.dataset.zoomAlt || '';
        lupa.hidden = false;
        document.body.setAttribute('data-bolsa-abierta', '');
        lupa.querySelector('[data-zoom-cerrar]').focus();
        return;
      }
      /* Cerrar: la X, o tocar fuera de la imagen. No cerrar si el toque
         terminó un arrastre, porque entonces querías moverte, no salir. */
      var fuera = e.target.closest('[data-zoom-lienzo]') && e.target.tagName !== 'IMG';
      if (e.target.closest('[data-zoom-cerrar]') || (fuera && !huboArrastre)) {
        cerrarLupa();
      }
    });

    function cerrarLupa() {
      lupa.hidden = true;
      document.body.removeAttribute('data-bolsa-abierta');
      if (focoLupa) focoLupa.focus();
    }

    /* Paneo con el dedo dentro de la lupa. Se usa scrollLeft/scrollTop en vez
       de transform para no pelear con el scroll nativo del contenedor. */
    var lienzo = lupa.querySelector('[data-zoom-lienzo]');
    var arrastrando = false, huboArrastre = false, x0 = 0, y0 = 0, sx = 0, sy = 0;
    if (lienzo) {
      lienzo.addEventListener('pointerdown', function (e) {
        arrastrando = true; huboArrastre = false;
        x0 = e.clientX; y0 = e.clientY;
        sx = lienzo.scrollLeft; sy = lienzo.scrollTop;
        lienzo.setAttribute('data-arrastrando', '');
      });
      lienzo.addEventListener('pointermove', function (e) {
        if (!arrastrando) return;
        var dx = e.clientX - x0, dy = e.clientY - y0;
        if (Math.abs(dx) > 4 || Math.abs(dy) > 4) huboArrastre = true;
        lienzo.scrollLeft = sx - dx;
        lienzo.scrollTop = sy - dy;
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
        lienzo.addEventListener(ev, function () {
          arrastrando = false;
          lienzo.removeAttribute('data-arrastrando');
        });
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lupa.hidden) cerrarLupa();
    });
  }

  /* ---------- Zoom al pasar el cursor (escritorio) ---------- */
  /* La ampliación pasa dentro de la placa: el marco no se rompe. El origen
     sigue al cursor, así que se amplía exactamente donde estás mirando. */
  (function () {
    if (!window.matchMedia('(pointer:fine)').matches) return;
    var placas = document.querySelectorAll('.galeria__foto .placa');
    for (var i = 0; i < placas.length; i++) {
      (function (placa) {
        if (!placa.querySelector('.placa__img')) return;   // sin foto, sin zoom
        placa.addEventListener('pointerenter', function () {
          placa.setAttribute('data-ampliando', '');
        });
        placa.addEventListener('pointermove', function (e) {
          var r = placa.getBoundingClientRect();
          placa.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
          placa.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
        });
        placa.addEventListener('pointerleave', function () {
          placa.removeAttribute('data-ampliando');
        });
      })(placas[i]);
    }
  })();

  /* ---------- Filtro de tipo en colección: instantáneo, sin recargar ---------- */
  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-tipo-filtro]');
    var limpiar = e.target.closest('[data-tipo-limpiar]');
    if (!boton && !limpiar) return;

    var tipo = limpiar ? '' : boton.dataset.tipoFiltro;
    var chips = document.querySelectorAll('[data-tipo-filtro]');
    for (var i = 0; i < chips.length; i++) {
      var activo = chips[i].dataset.tipoFiltro === tipo;
      chips[i].classList.toggle('chip--activo', activo);
      chips[i].setAttribute('aria-pressed', String(activo));
    }

    var celdas = document.querySelectorAll('.parrilla__celda');
    var visibles = 0;
    for (var j = 0; j < celdas.length; j++) {
      var ok = !tipo || celdas[j].dataset.tipo === tipo;
      celdas[j].hidden = !ok;
      if (ok) visibles++;
    }
    var claros = document.querySelectorAll('.parrilla__claro');
    for (var k = 0; k < claros.length; k++) claros[k].hidden = !!tipo;

    var vacio = document.querySelector('[data-vacio]');
    if (vacio) vacio.hidden = visibles > 0;
    var conteo = document.querySelector('[data-conteo]');
    if (conteo) conteo.textContent = visibles + (visibles === 1 ? ' pieza' : ' piezas');
  });

  window.FeralDinero = dinero;
})();
